
import {h} from "preact";
import Breakdown from "./Breakdown";
import sumPartsByWeight from "../sum/sumPartsByWeight";
import {isOnHold} from "../filters/hold";


export type OverrunByWeightProps = {
  part: string
}

export function UndatedByWeight(props: OverrunByWeightProps) {
  const {part} = props;

  return <Breakdown
    title={`${part}`}
    description={ "On Hold, Weight (tonnes)" }
    filter={(quotes) => quotes.filter(isOnHold)}
    sum={(items) => sumPartsByWeight(part, items).toString()}
  />
}

export default UndatedByWeight;
